var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnified(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8 6a4.8 4.8 0 01-5.543 4.743 4.8 4.8 0 015.486-5.486c.037.242.057.49.057.743zm-.43-1.989A6 6 0 004.01 10.37 4.8 4.8 0 1110.37 4.01zm1.373.246a6 6 0 10-7.486 7.486 6 6 0 107.486-7.486zm.246 1.373A6 6 0 015.63 11.99 4.8 4.8 0 1011.99 5.63z",
    fill: "#979797"
  })));
}
export default SvgUnified;